
import { useEffect } from 'react';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';
import { useSEO } from '../../utils/seo';

export default function MentionsLegales() {
  useSEO({
    title: 'Mentions légales — OTOROBOTS CANADA INC.',
    description: 'Mentions légales d\'OTOROBOTS CANADA INC. : identification de l\'entreprise, propriété intellectuelle, limitation de responsabilité et informations juridiques.',
    keywords: 'mentions légales, OTOROBOTS, informations juridiques, Canada',
    canonical: '/mentions-legales',
    ogTitle: 'Mentions légales — OTOROBOTS CANADA INC.',
    ogDescription: 'Mentions légales d\'OTOROBOTS CANADA INC. : identification de l\'entreprise, propriété intellectuelle et informations juridiques.',
    schema: {
      '@type': 'WebPage',
      name: 'Mentions légales',
      description: 'Mentions légales d\'OTOROBOTS CANADA INC.',
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <header>
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-8">
              Mentions légales
            </h1>
          </header>

          <article className="space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Identification de l'entreprise
              </h2>
              <p className="mb-3">
                <strong>Nom de l'entreprise :</strong> OTOROBOTS CANADA INC.
              </p>
              <p className="mb-3">
                <strong>Statut juridique :</strong> Société incorporée au Canada
              </p>
              <p className="mb-3">
                <strong>Contact :</strong> info@otorobots.com
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Nature du site
              </h2>
              <p>
                Le site web d'OTOROBOTS CANADA INC. est un site à vocation informative et institutionnelle. 
                Il a pour objectif de présenter l'entreprise, sa vision, ses valeurs et ses activités. 
                Aucune vente directe de produits ou services n'est effectuée sur ce site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Propriété intellectuelle
              </h2>
              <p>
                L'ensemble du contenu présent sur ce site (textes, images, logos, graphismes, vidéos) 
                est la propriété exclusive d'OTOROBOTS CANADA INC., sauf mention contraire. 
                Toute reproduction, distribution ou utilisation sans autorisation préalable est interdite 
                et peut faire l'objet de poursuites conformément aux lois applicables sur la propriété intellectuelle.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Limitation de responsabilité
              </h2>
              <p className="mb-3">
                OTOROBOTS CANADA INC. s'efforce de fournir des informations exactes et à jour sur ce site. 
                Toutefois, l'entreprise ne peut garantir l'exactitude, la complétude ou l'actualité des informations diffusées.
              </p>
              <p>
                L'entreprise décline toute responsabilité pour les dommages directs ou indirects qui pourraient 
                résulter de l'accès au site ou de l'utilisation des informations qu'il contient, dans les limites 
                permises par la loi applicable.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Liens externes
              </h2>
              <p>
                Ce site peut contenir des liens vers des sites externes. OTOROBOTS CANADA INC. n'exerce aucun 
                contrôle sur ces sites et décline toute responsabilité quant à leur contenu, leur disponibilité 
                ou leurs pratiques.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Loi applicable
              </h2>
              <p>
                Les présentes mentions légales sont régies par les lois en vigueur au Canada. 
                Tout litige relatif à l'utilisation de ce site sera soumis à la juridiction compétente canadienne.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                Contact
              </h2>
              <p>
                Pour toute question concernant ces mentions légales, vous pouvez nous contacter à l'adresse suivante :
              </p>
              <p className="mt-2">
                <a href="mailto:info@otorobots.com" className="text-teal-600 hover:text-teal-700 font-medium">
                  info@otorobots.com
                </a>
              </p>
            </section>
          </article>
        </div>
      </main>

      <Footer />
    </div>
  );
}
